/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Focus_HelpInputs */



/**
* | output |
* | --- |
* | "Select what the AI should emphasise. Leave at least one option enabled." |
*
* @param {Ad_Description_Focus_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_focus_help = /** @type {((inputs?: Ad_Description_Focus_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Focus_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez les éléments que l'IA doit mettre en avant. Laissez au moins une option activée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie aus, worauf die KI Wert legen soll. Lassen Sie mindestens eine Option aktiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona gli elementi su cui l'IA deve concentrarsi. Lascia almeno un'opzione attiva.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите, на чём ИИ должен сделать акцент. Оставьте хотя бы один вариант включенным.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selecciona qué aspectos debe destacar la IA. Deja al menos una opción habilitada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择人工智能应该重点关注的内容。至少启用一个选项。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIが強調すべき項目を選択してください。少なくとも1つのオプションは有効にしておいてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह चुनें कि एआई को किस पर जोर देना चाहिए। कम से कम एक विकल्प को सक्षम रखें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o que a IA deve enfatizar. Deixe pelo menos uma opção ativada.")
	return /** @type {LocalizedString} */ ("Select what the AI should emphasise. Leave at least one option enabled.")
});